import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Form, Spinner } from "react-bootstrap"; // Import Modal and Form components
import { API_URL } from "..";

const InvoicePreviewLayer = ({ data }) => {
  
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const [message, setMessage] = useState({
    status: false,
    reason: "",
    desc: "",
  });
  const [showDiscount, setShowDiscount] = useState(false);
  const [showTax, setShowTax] = useState(false);
  const [editingField, setEditingField] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState(data?.items);
  const [discount, setDiscount] = useState(parseFloat(data?.discount));
  const [taxAmount, setTaxAmount] = useState(parseFloat(data?.tax));

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [sendMethod, setSendMethod] = useState("email"); // Default to email
  const [sendValue, setSendValue] = useState(""); // Email or phone input

  const handleDiscountChange = (value) => {
    setDiscount(value);
  };
  const handleTaxChange = (value) => {
    setTaxAmount(value);
  };

  const calculateSubtotal = () => {
    const subtotal = invoiceItems.reduce((acc, item) => acc + parseFloat(item.price), 0);
    return subtotal;
  };

  const calculateDiscountedTotal = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = (subtotal * discount) / 100;
    return subtotal - discountAmount;
  };

  const calculateTax = (total) => (total * taxAmount) / 100;

  const calculateTotal = () => {
    const discountedTotal = calculateDiscountedTotal();
    return discountedTotal + calculateTax(discountedTotal);
  };

  // Handle Send Invoice button click
  const handleSendInvoiceClick = (e) => {
    e.preventDefault(); // Prevent default Link behavior
    setShowModal(true); // Show the modal
  };

  // Handle Send action
  const handleSend = async () => {
    try {
      const payload = {
        invoiceId: data?.id,
        method: sendMethod,
        value: sendValue, // Email or phone number
      };
      // Example API call (adjust to your API)
      const response = await fetch(`${API_URL}/api/invoice/send-invoice`, {
        method: "POST",
        headers: {
            "Accept": "*/*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (response.ok) {
        setMessage({
          status: true,
          reason: "Success",
          desc: `${sendMethod === "email" ? "Email" : "SMS"} sent successfully!`,
        });
      } else {
        throw new Error(result.message || "Failed to send");
      }
    } catch (error) {
      setMessage({
        status: false,
        reason: "Error",
        desc: error.message,
      });
    }
    setShowModal(false); // Close modal after sending
    setSendValue(""); // Reset input
  };

  return (

    <div className="card">
            
      <div className="card-header">
        <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
          <Link
            to="#"
            onClick={handleSendInvoiceClick} // Trigger modal
            className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center gap-1"
          >
            <Icon icon="pepicons-pencil:paper-plane" className="text-xl" />
            Send Invoice
          </Link>
          <Link
            to={`/edit-invoice/${data?.id}`}
            className="btn btn-sm btn-success radius-8 d-inline-flex align-items-center gap-1"
          >
            <Icon icon="uil:edit" className="text-xl" />
            Edit
          </Link>
       
        </div>
      </div>
      <div className="card-body py-40">
        <div className="row justify-content-center" id="invoice">
          <div className="col-lg-8">
            <div className="pdf-container" style={{ width: "100%", height: "800px" }}>
              <iframe
                src={data?.recepit_url}
                width="100%"
                height="100%"
                title="PDF Viewer"
                style={{ border: "none" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Send Invoice */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="d-flex gap-4 mb-3">
              <Form.Check
                inline
                type="radio"
                label="Send on Email"
                name="sendMethod"
                id="sendEmail"
                value="email"
                checked={sendMethod === "email"}
                onChange={(e) => setSendMethod(e.target.value)}
              />
              <Form.Check
                inline
                type="radio"
                label="Send on Phone"
                name="sendMethod"
                id="sendPhone"
                value="phone"
                checked={sendMethod === "phone"}
                onChange={(e) => setSendMethod(e.target.value)}
              />
            </div>

            {sendMethod === "email" ? (
              <Form.Group controlId="emailInput">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={sendValue}
                  onChange={(e) => setSendValue(e.target.value)}
                  className="radius-8"
                />
              </Form.Group>
            ) : (
              <Form.Group controlId="phoneInput">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="Enter phone number"
                  value={sendValue}
                  onChange={(e) => setSendValue(e.target.value)}
                  className="radius-8"
                />
              </Form.Group>
            )}
          </Form>
          {message.reason && (
            <div
              className={`mt-3 alert ${
                message.status ? "alert-success" : "alert-danger"
              }`}
            >
              <strong>{message.reason}:</strong> {message.desc}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSend}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default InvoicePreviewLayer;